import { loading } from '@/shared/utils/UIHelper'
import ParametroConfigVisitasRepository from '@/shared/http/repositories/configurations/parametroConfigVisitas.js'

export default {
  name: 'visitasConfig',
  data () {
    return {
      visitasConfig: null
    }
  },
  async mounted () {
    this.visitasConfig = await this.getVisitasConfig()
  },
  methods: {
    async getVisitasConfig () {
      try {
        loading.push()
        const resp = await ParametroConfigVisitasRepository.Get()

        if (!resp || !resp.data) {
          return
        }

        return resp.data
      } catch (error) {
        console.error(error)
      } finally {
        loading.close()
      }
    },
    hasHodometroVisitas () {
      if (this.visitasConfig && this.visitasConfig.hasHodometro) {
        return true
      }
      return false
    },
    async hasHodometroVisitasRelatorio () {
      if (!this.visitasConfig) {
        const {hasHodometro} = await this.getVisitasConfig()
        return hasHodometro
      }

      if (this.visitasConfig.hasHodometro) {
        return true
      }
      return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/mixins/visitasConfig.js